module.exports = __webpack_public_path__ + "static/media/success.40845a68.gif";